import { useEffect, useState } from 'react';

export const useDebouncedValue = <T>(value: T, ms: number): T => {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), ms);
    return () => window.clearTimeout(timer);
  }, [value, ms]);

  return settled;
};
